<script setup>
/* eslint-disable */
import { ref } from "vue";
import { useBetBoosterStore } from "@/stores/bet_booster";
import { useI18n } from "vue-i18n";

const betBoosterStore = useBetBoosterStore();
const competitions_opened = ref(true);
const { t } = useI18n();

const selectCompetition = (competitionId) => {
	if (betBoosterStore.selected_competition_id === competitionId) {
		betBoosterStore.setSelectedCompetition(null);
	} else {
		betBoosterStore.setSelectedCompetition(competitionId);
	}
};
</script>

<template>
	<div class="accordion-item" :class="competitions_opened ? 'active': ''">
		<div class="accordion-header" @click="competitions_opened = !competitions_opened">
			<span>
				{{ $t('bet_boost.boosted_competitions', 'Boosted Leagues') }}
				
				<span v-if="betBoosterStore.availableCompetitions.length" class="header-count">
					({{ betBoosterStore.availableCompetitions.length }})
				</span>
			</span>
			<div class="acoordion-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
					<g id="Group_776" data-name="Group 776" transform="translate(-272 -6)">
						<g id="minimize" transform="translate(272 10)">
							<rect id="Rectangle_408" data-name="Rectangle 408" width="1" height="9" rx="0.5" transform="translate(9) rotate(90)" fill="var(--white)" />
						</g>
						<g id="minimize-2" class="hide-i" data-name="minimize" transform="translate(277 6) rotate(90)">
							<rect id="Rectangle_408-2" data-name="Rectangle 408" width="1" height="9" rx="0.5" transform="translate(9) rotate(90)" fill="var(--white)" />
						</g>
					</g>
				</svg>
			</div>
		</div>

		<div class="accordion-content" v-if="competitions_opened">
			<div class="top-league-outer">
				<div style="cursor: pointer;">
					<!-- All Leagues option -->
					<div
						@click="betBoosterStore.setSelectedCompetition(null)"
						class="country-info-inner top-league boost-sidebar-item"
						:class="{ 'active': betBoosterStore.selected_competition_id == null }"
					>
						<div class="country-left">
							<div class="boost-sidebar-icon">🚀</div>
							<div class="country-name text-capitalize">
								<h3>{{ $t('general.all_leagues', 'All Leagues') }}</h3>
							</div>
						</div>
						<!-- <div class="country-right" v-if="betBoosterStore.filteredBoostedBets.length">
							<span class="boost-count-badge">{{ betBoosterStore.filteredBoostedBets.length }}</span>
						</div> -->
					</div>

					<!-- Individual Boosted Competitions -->
					<div
						v-for="competition in betBoosterStore.availableCompetitions"
						:key="competition.id"
						@click="selectCompetition(competition.id)"
						class="country-info-inner top-league boost-sidebar-item"
						:class="{ 'active': betBoosterStore.selected_competition_id == competition.id }"
					>
						<div class="country-left">
							<div class="country-flag" v-if="competition.region_icon">
								<img :src="'/assets' + competition.region_icon" alt="flag-country">
							</div>
							<div class="country-name text-capitalize">
								<h3>{{ competition.name }}</h3>
							</div>
						</div>
						<!-- <div class="country-right">
							<span class="boost-count-badge">{{ competition.count }}</span>
						</div> -->
					</div>

					<div v-if="!betBoosterStore.availableCompetitions.length" class="no-boost-leagues">
						<span>{{ $t('bet_boost.no_boosted_leagues', 'No boosted leagues') }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.boost-sidebar-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: background-color 0.15s ease;
}

.boost-sidebar-icon {
	font-size: 13px;
	margin-right: 8px;
	display: inline-flex;
	align-items: center;
}

.header-count {
	font-size: 11px;
	color: var(--primary);
	margin-left: 6px;
	font-weight: 700;
}

.boost-count-badge {
	font-size: 11px;
	font-weight: 700;
	padding: 1px 7px;
	border-radius: 10px;
	background: rgba(var(--primary-rgb, 99, 162, 70), 0.18);
	color: var(--primary);
}

.country-info-inner.top-league.active .boost-count-badge {
	background: var(--primary);
	color: var(--white);
}

.no-boost-leagues {
	padding: 14px 12px;
	font-size: 12px;
	color: var(--light-gray);
	text-align: center;
}
</style>
